import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link , useNavigate} from "react-router-dom";
import moment from "moment";
import './AvailableEventItem.styles.css';
import { useTranslation } from "react-i18next";
import ProgressControl from "../status-control/ProgressControl.component";
import { addPad, getEventColor } from "../../utils/helperFn";
import StatusControl from "../status-control/StatusControl.component";
import CustomToolTip from "../custom-tooltip/CustomTooltip.component";

const AvailableEventItem = ({data, isMobile, eventHandler, refId}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const btnParentRef = React.useRef(null);
    const btnRef = React.useRef(null);
    const [btnEllipsis, setBtnEllipsis] = React.useState(false);

    React.useEffect(() => {
        if(!!btnParentRef?.current) {
            var styles = window.getComputedStyle(btnParentRef?.current);

            // console.log("Parent", btnParentRef?.current?.getBoundingClientRect().width, parseFloat(styles['paddingTop']) + parseFloat(styles['paddingBottom']), btnRef?.current?.offsetWidth, data )
        
            if((btnParentRef?.current?.getBoundingClientRect().width - (parseFloat(styles['paddingTop']) + parseFloat(styles['paddingBottom']))) <= btnRef?.current?.offsetWidth) {
                setBtnEllipsis(true);
            }
        }

    }, [btnParentRef, btnRef])

    const handleChange = () => {
      navigate(`/event/${data.eventId}${refId ? `?refId=${refId}` : ''}`, { state: { eventId: data.eventId } });
    };

    const navigateToCandidateReport = (eventId) => {
      navigate(
        `/candidate-report?eventId=${eventId}&reportType=${
          data?.sharedEventReportCount > 0 ? "EVENT" : "TASK"
        }${refId ? "&refId=" + refId : ""}`
      );
    };

    const viewReportButtonFlag = React.useMemo(() => {
        return data.sharedTaskReportCount > 0 || data?.sharedEventReportCount > 0;
    }, [data?.sharedTaskReportCount, data?.sharedEventReportCount]);
    return(
        <>
        {!isMobile ? 
            <div className="cm-available-events-item py-3 d-flex px-2 align-items-center">
                <div className="col-sm-2">
                    <p className="my-0 cm-sm-txt fw-medium cm-truncate-1 text-blue-800"><div className="text-gray-700 cm-pointer" onClick={()=>handleChange()}>{data.eventName}</div></p>
                    <span className="cm-sm-txt text-blue-gray-700">{addPad(data.taskCount)} {data.taskCount > 1 ? t('tasks') : t('task')}</span>
                </div>
                <div className="col-sm-2 col-xl-2 overflow-hidden" ref={btnParentRef}>
                    {!!data.eventStatus && <span ref={btnRef} className={`cm-av-ev-status-pill my-0 cm-sm-txt fw-medium rounded-pill text-capitalize ${getEventColor(data.eventStatus?.toLowerCase())} ${btnEllipsis ? "d-flex" : "d-inline-block"}`}><span className="cm-truncate-1"><StatusControl value={data.eventStatus} /></span></span>}
                </div>
                <div className="col-sm-2 col-xl-2">
                    {!!data.candidateStatus && <p className="my-0 cm-sm-txt fw-medium text-blue-800"><ProgressControl value={data.candidateStatus} /></p>}
                    <span className="cm-sm-txt text-blue-gray-700">{!!data.pendingTaskCount ? data.pendingTaskCount : '0'}/{!!data.taskCount ? data.taskCount : '0'} {t("tasks_pending")}</span>
                </div>
                <div className="col-sm-3">
                    <p className="text-blue-800 my-0 cm-sm-txt">{moment(data.startDate).format('MMM DD YYYY @ hh:mm A')} {!!data.endDate && ` ${t('to')} ${moment(data.endDate).format('MMM DD YYYY @ hh:mm A')}`}</p>
                    {/* {data.timezone && <span className="cm-sm-txt text-blue-gray-700">{data.timezone}</span>} */}
                </div>
                <div className="col-sm-2 cm-trucate-1">
                    <span className="my-0 cm-sm-txt fw-medium text-blue-gray-700">{data.hostedBy}</span>
                </div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                {viewReportButtonFlag &&
                <CustomToolTip title={t("reports")}>
                  <FontAwesomeIcon
                    icon={regular("file-chart-column")}
                    onClick={() => {navigateToCandidateReport(data.eventId)}}
                    className="cm-pointer text-blue-gray-700 py-1 px-2 me-3"
                  />
                </CustomToolTip>
              }
                    <CustomToolTip title={t("event_details")}>
                        <FontAwesomeIcon icon={regular("memo-circle-info")} 
                        className="cm-pointer text-blue-gray-700 py-1 px-2" 
                        onClick={()=>eventHandler(data.eventId)}
                        />
                    </CustomToolTip>
                </div>
            </div>
        :
            <div className="cm-available-events-item p-3 mx-3 mb-2">
                <p className="cm-sm-txt fw-semibold text-blue-800 cm-ev-title"><Link to={`/event/${data.eventId}`} state={{ eventId: data.eventId }} className="text-gray-700">{data.eventName}</Link></p>
                <div className="cm-row-1 d-flex align-items-center flex-wrap">
                    <span className={`cm-av-ev-status-pill cm-xs-txt fw-medium rounded-pill text-capitalize ${getEventColor(data.eventStatus.toLowerCase())}`}><StatusControl value={data.eventStatus} /></span>
                    <span className="cm-av-ev-task-pill ms-2 cm-xs-txt text-blue-gray-700 rounded-pill fw-medium">{!!data.pendingTaskCount ? data.pendingTaskCount : '0'}/{!!data.taskCount ? data.taskCount : '0'} {t("tasks_pending")}</span>
                </div>
                <div className="cm-row-2 d-flex align-items-center justify-content-between flex-wrap align-items-center mt-2">
                    <p className="cm-av-ev-task-pill rounded-pill text-gray-700 my-0 cm-xs-txt fw-semibold text-blue-700"><span className="fw-medium text-blue-gray-700 text-capitalize">{t("timeline")}:</span> {moment(data.startDate).format('MMM DD YYYY')} {!!data.endDate && `- ${moment(data.endDate).format('MMM DD YYYY')}`}</p>
                    <div className="d-flex align-items-center">
                        {data.showReportBtn && <FontAwesomeIcon icon={regular("file-chart-column")} onClick={() => {navigateToCandidateReport(data.eventId)}} className="cm-pointer text-blue-gray-700 py-1 px-2 mx-3" />}
                        <FontAwesomeIcon icon={regular("memo-circle-info")} className="cm-pointer text-blue-gray-700 py-1 px-2" onClick={()=>handleChange()} />
                    </div>
                </div>
            </div>}
            </>
    )

}

export default AvailableEventItem;